<script setup>
import IconButton from '@/components/shared/IconButton.vue';
import VideosGrid from './VideosGrid.vue';
import PicturesGrid from './PicturesGrid.vue';
import { useMatomo } from '@/stores/useMatomo';

const emit = defineEmits([
  'close',
  'item-selected',
  'gallery-picture-selected',
]);

defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  mediaType: {
    type: String,
    default: 'pictures',
  },
  canClose: {
    type: Boolean,
    default: false,
  },
});

const { trackEvent } = useMatomo();

function close() {
  trackEvent('Click', 'Navigation', 'close');
  emit('close');
}

function mediaSelected(index) {
  emit('item-selected', index);
}
</script>

<template>
  <div
    class="media-list"
    :class="{
      galleries: mediaType === 'galleries',
    }"
  >
    <IconButton
      v-if="canClose"
      :icon="['fal', 'times']"
      @click="close"
      class="mb-12"
    />

    <PicturesGrid
      v-if="mediaType === 'pictures'"
      :pictures="items.map((picture) => picture.source)"
      @picture-selected="mediaSelected"
    />

    <VideosGrid
      :videos="items"
      @video-selected="mediaSelected"
      v-else-if="mediaType === 'videos'"
    />
  </div>
</template>
